'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeClientSuccessIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeClientSuccessIcon">
      <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_281_27835)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.1429 0C21.4917 0 12.8571 8.63453 12.8571 19.2857C12.8571 29.9369 21.4917 38.5714 32.1429 38.5714C42.794 38.5714 51.4286 29.9369 51.4286 19.2857C51.4286 8.63453 42.794 0 32.1429 0ZM32.1429 45C14.3909 45 0 59.3909 0 77.1429V80.3571C0 82.1321 1.43909 83.5714 3.21429 83.5714H36.5669C32.9854 79.1023 32.7271 72.6152 36.3222 67.8221C40.5827 62.1413 48.6415 60.99 54.3222 65.2506L57.21 67.4164L60.9111 62.79C55.6387 52.2427 44.7366 45 32.1429 45Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M88.1904 49.2716C90.2694 50.935 90.6069 53.969 88.9432 56.0484L63.2289 88.1909C61.6021 90.2249 58.6545 90.599 56.5711 89.0363L43.714 79.3934C41.5838 77.7959 41.1521 74.7738 42.7497 72.6434C44.3474 70.5136 47.3695 70.0816 49.4997 71.6791L58.6184 78.5185L81.4134 50.0245C83.0772 47.9452 86.1108 47.6081 88.1904 49.2716Z"
            fill="#5073C3"
          />
        </g>
        <defs>
          <clipPath id="clip0_281_27835">
            <rect width="90" height="90" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LargeClientSuccessIcon.propTypes = {
  sx: PropTypes.object
}
